import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  dialogContainer: {
    width: '480px',
    height: '340px',
    overflow: 'hidden',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  content: {
    padding: '36px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'relative',
  },

  closeButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    padding: '8px',
    zIndex: 1,
  },

  titleSpace: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  titleTextSpace: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  headingText: {
    textAlign: 'center',
  },

  subtitleSpace: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  subtitleText: {
    textAlign: 'center',
    marginTop: '8px',
  },

  inputSpace: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  otpContainer: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    alignItems: 'center',
  },

  otpBox: {
    width: '48px',
    height: '56px',
    '& input': {
      textAlign: 'center',
      fontSize: '24px',
      fontWeight: 600,
      padding: '12px 0',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      '& fieldset': {
        borderColor: '#E0E0E0',
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
        borderWidth: '2px',
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
        borderWidth: '2px',
      },
      '&.Mui-error fieldset': {
        borderColor: theme.palette.error.main,
      },
    },
  },

  errorText: {
    color: theme.palette.error.main,
    marginTop: '8px',
    textAlign: 'center',
  },

  successText: {
    color: theme.palette.success.main,
    marginTop: '8px',
    textAlign: 'center',
  },

  buttonSpace: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: '16px',
  },

  textButton: {
    textTransform: 'none',
    fontWeight: 400,
  },

});

export default styles;
export const useStyles = makeStyles(styles);
